import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { StorageBase } from "./storage-base";
let LocalStorageService = class LocalStorageService extends StorageBase {
    constructor() {
        super(window.localStorage);
    }
    static ctorParameters = () => [];
};
LocalStorageService = __decorate([
    Injectable({
        providedIn: "root"
    })
], LocalStorageService);
export { LocalStorageService };
